import { errorTypes } from '../../reducers/types';

export default () => ({
  type: errorTypes.RESET_ERRORS,
});
